import React, { Suspense } from 'react'

const LazyOrb = React.lazy(() => import('./Orb').then(module => ({ default: module.Orb })))

export const Orb: React.FC = props => (
  <Suspense fallback={null}>
    <LazyOrb {...props} />
  </Suspense>
)
